/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import { ComponentPath } from '@karya/generic-task-react';
import { VStack } from 'chakra-v3';
import { ChatMessage } from '../helpers/task-renderer/chakra/shared/ChatMessage';
import { PlatformComponentRenderer } from '../helpers/task-renderer/renderers/PlatformComponentRenderer';
import StartComponentRenderer from '../helpers/task-renderer/renderers/StartComponentRenderer';
import { UserComponentRenderer } from '../helpers/task-renderer/renderers/UserComponentRenderer';

export interface RenderExecutionHistoryProps {
  history: ComponentPath;
}

export function RenderExecutionHistory(props: RenderExecutionHistoryProps) {
  if (props.history.length === 0) {
    return null;
  }

  return (
    <VStack gap="0" align="stretch">
      {props.history.map((node, index) => {
        const ctype = node.component.ctype;

        if (ctype === 'END') {
          return null;
        }

        if (ctype === 'START') {
          return (
            <StartComponentRenderer
              key={`${node.component.key}-${index}`}
              node={node}
              controller={null}
              isCurrent={false}
            />
          );
        }

        if (ctype === 'PLATFORM') {
          return (
            <ChatMessage key={`${node.component.key}-${index}`} isPlatform={true}>
              <PlatformComponentRenderer node={node} controller={null} isCurrent={false} />
            </ChatMessage>
          );
        }

        if (ctype === 'USER') {
          return (
            <ChatMessage key={`${node.component.key}-${index}`} isPlatform={false}>
              <UserComponentRenderer node={node} controller={null} isCurrent={false} />
            </ChatMessage>
          );
        }

        return null;
      })}
    </VStack>
  );
}
